var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentItem',{attrs:{"name":_vm.name}},[_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.$t('메시지_목록에_표시할_메시지_개수를_선택해_주세요')))]),_c('Dropdown',{style:('width:200px;'),attrs:{"items":_vm.count,"selected":_vm.selectedCount},on:{"change":_vm.select}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }